// Fixed to en-US so server and browser render the same digits.
const whole = new Intl.NumberFormat("en-US");
const short = new Intl.NumberFormat("en-US", {
	notation: "compact",
	maximumFractionDigits: 1,
});

/** 1234567 → "1,234,567". */
export function formatNumber(value: number | bigint): string {
	return whole.format(value);
}

/** 1234 → "1.2k", 2500000 → "2.5M". */
export function formatCompactNumber(value: number): string {
	return short.format(value).replace("K", "k");
}

/** Chart tooltip text: numbers grouped, strings as they are, lists joined. */
export function formatChartValue(
	value: number | string | (number | string)[],
): string {
	if (Array.isArray(value)) {
		return value.map(formatChartValue).join(", ");
	}
	return typeof value === "number" ? formatNumber(value) : value;
}
